import React from 'react';
import { Link } from 'react-router-dom';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

export const HOME_FAQ = [
  {
    q: 'What is the minimum order for Italian food export?',
    a: 'It depends on the producer, but because we consolidate multiple producers into one shipment, you can reach a full container without committing to a large volume from any single supplier. Mixed pallets are normal for a first order.',
  },
  {
    q: 'How long does shipping from Italy take?',
    a: 'Within the EU, typically a few days to a week by road. To the USA and Canada, roughly three to five weeks door to door by sea, depending on port and clearance. Air freight is available for samples and urgent orders.',
  },
  {
    q: 'Do you handle export documentation and certification?',
    a: 'Yes. Health certificates, certificates of origin, customs classification, and nutritional and labelling data for your destination market are part of the service.',
  },
  {
    q: 'Can you produce under our own brand?',
    a: 'Yes. We manage private label across most categories, from producer selection and recipe adjustment through packaging, labelling and export.',
  },
  {
    q: 'Which product categories do you cover?',
    a: 'Pasta and grains, preserved foods, cheese and dairy, olive oil and condiments, cured meats and salumi, bakery and pastry, and soft beverages.',
    aRender: (
      <>Pasta and grains, preserved foods, cheese and dairy, olive oil and condiments, cured meats and salumi, <Link to="/categories/italian-pastry-bakery" className="text-blue-900 underline underline-offset-2 hover:text-amber-600 transition-colors">bakery and pastry</Link>, and soft beverages.</>
    ),
  },
  {
    q: 'How do you check quality?',
    a: 'We audit producers in person before we work with them, and we inspect orders before loading in Italy. Every batch carries lot traceability and, where relevant, analysis certificates.',
  },
];

const FaqSection = () => {
  return (
    <section
      id="faq"
      className="py-20 px-6 bg-gradient-to-br from-amber-50 via-stone-50 to-orange-50"
      data-testid="faq-section"
    >
      <div className="container mx-auto max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-blue-900 font-semibold tracking-wide uppercase text-sm">COMMON QUESTIONS</p>
          <h2 className="md:text-5xl !font-bold !text-4xl mt-3 mb-6 text-stone-900">Questions buyers ask us</h2>
          <p className="text-lg text-stone-600">The six things importers want to know before they start.</p>
        </div>
        <Accordion type="single" collapsible className="max-w-3xl mx-auto">
          {HOME_FAQ.map((item, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left text-stone-900 font-semibold hover:text-blue-900">
                {item.q}
              </AccordionTrigger>
              <AccordionContent forceMount className="text-stone-600 leading-relaxed text-base">
                {item.aRender || item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FaqSection;
